import { useNavigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { ORGANIZATION_TAB_PERMISSIONS } from '../../config/permissionMapping';
import NotificationBell from '../NotificationBell/NotificationBell';
import StatusBar from '../StatusBar/StatusBar';
import './Header.css';

function Header({ onToggleSidebar, isSidebarOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasAnyPermission, permissionsLoaded } = usePermissions();

  const isActive = (path) => location.pathname === path;
  const isOrganizationPage = location.pathname === '/app/organization';

  // Check if user has any organization permissions
  const hasOrganizationAccess = permissionsLoaded && hasAnyPermission(
    Object.values(ORGANIZATION_TAB_PERMISSIONS)
      .filter(perm => perm !== null)
      .map(perm => ({ resource: perm.resource, action: perm.action }))
  );

  // Only show organization menu if user has permissions
  const menuItems = hasOrganizationAccess ? [
    { path: '/app/organization', label: 'Organization', icon: 'fas fa-building' }
  ] : [];

  return (
    <header className="header">
      <div className="header-content">
        {isOrganizationPage ? (
          <button
            className="btn-back-to-chat-header"
            onClick={() => navigate('/app')}
            title="Back to Chat"
          >
            <i className="fas fa-arrow-left"></i>
            <span>Back to Chat</span>
          </button>
        ) : (
          <nav className="header-nav">
            {/* Mobile sidebar toggle - opens chat history sidebar */}
            {onToggleSidebar && (
              <button
                className="mobile-sidebar-toggle"
                onClick={() => {
                  console.log('Hamburger clicked, toggling sidebar')
                  onToggleSidebar()
                }}
                title={isSidebarOpen ? "Close sidebar" : "Open sidebar"}
              >
                <i className="fas fa-bars"></i>
              </button>
            )}

            <div className="nav-menu">
              {menuItems.map(item => (
                <button
                  key={item.path}
                  className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => navigate(item.path)}
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </button>
              ))}
            </div>

            {hasOrganizationAccess && <StatusBar />}
            <NotificationBell />

          </nav>
        )}

      </div>
    </header>
  );
}

export default Header;
